import { get, post, destroy } from "./base";

const WishlistServ = {
    getWishlist: () => get("/wishlist"),
    toggleWishlist: (productId) => post("/wishlist/toggle", { productId }),
    removeFromWishlist: (productId) => destroy(`/wishlist/${productId}`),
};

export default WishlistServ;
